import { render, staticRenderFns } from "./PerfilAcessoEditPermission.vue?vue&type=template&id=3d445f28&"
import script from "./PerfilAcessoEditPermission.vue?vue&type=script&lang=js&"
export * from "./PerfilAcessoEditPermission.vue?vue&type=script&lang=js&"
import style0 from "./PerfilAcessoEditPermission.vue?vue&type=style&index=0&id=3d445f28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports